export default __webpack_public_path__ + "static/media/question-mark-icon.e801f9e4.svg";